



































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { getFileUrl } from '@/utils';
import VideoToolbar from '../Toolbars/VideoToolbar.vue';
import MediaFileOverlay from './MediaFileOverlay.vue';
import { Action, Getter } from 'vuex-class';
import { VideoElement as VideoElementType, ElementActionsKeys, ElementActionsPayload } from '@/store/types/element';
import { RootGettersReturns } from '@/store/types';
import { StageActionsKeys, StageActionsPayload } from '@/store/types/stageState';
import { SessionStatus } from '@/store/types/session';

@Component({
  components: {
    VideoToolbar,
    MediaFileOverlay,
  },
})
export default class VideoElement extends Vue {
  @Prop(String) filename!: string;
  @Prop(Boolean) selected!: boolean;
  @Prop(Boolean) doubleSelected!: boolean;
  @Prop({ type: Object }) element!: VideoElementType;

  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sessionUsers!: RootGettersReturns['sessionUsers'];
  @Getter videoState!: RootGettersReturns['videoState'];
  @Getter sessionStatus!: RootGettersReturns['sessionStatus'];

  @Action(ElementActionsKeys.SET_DOUBLE_SELECTED) setDouble!: (
    payload: ElementActionsPayload['SET_DOUBLE_SELECTED']
  ) => void;
  @Action(StageActionsKeys.SET_VIDEO_STATE) setVideoState!: (payload: StageActionsPayload['SET_VIDEO_STATE']) => void;
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;

  @Ref('video') video!: HTMLVideoElement;

  url = '';
  setUrl = false;
  isPlaying = false;
  isFullyLoaded = false;
  displayedOverlay = false;

  get playable() {
    return (
      this.sessionStatus !== SessionStatus.STARTED ||
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.sessionUsers.length - 1 <= (this.videoState[this.element.id!] || []).length
    );
  }

  async mounted() {
    this.$parent.$parent.$emit('updateMoveableComponent', {
      keepRatio: true,
    });
    await this.setNewUrl();
    this.setUrl = true;
    if (this.isFullyLoaded) {
      this.video.currentTime = this.element.data.lastSeeked || 0;
    }

    setTimeout(this.fullyLoaded, 10000);
  }

  async setNewUrl() {
    this.url = await getFileUrl(this.filename);
  }

  videoIsPlaying(target: HTMLVideoElement) {
    return !!(target.currentTime > 0 && !target.paused && !target.ended && target.readyState > 2);
  }

  onError() {
    if (this.setUrl) {
      this.setNewUrl();
    }
  }

  @Watch('doubleSelected')
  doubleClicked(newVal: boolean) {
    this.$parent.$parent.$emit('changeMoveable', !newVal);
    this.setDouble(newVal);
  }

  @Watch('element', { deep: true })
  elementUpdate(newVal: VideoElementType, oldValue: VideoElementType) {
    if (this.isGuest) {
      if (newVal.data.lastSeeked !== oldValue.data.lastSeeked) {
        this.video.currentTime = newVal.data.lastSeeked || 0;
      }
      if (newVal.data.state !== oldValue.data.state) {
        if (newVal.data.state === 'playing') {
          this.video.muted = true;
          this.video.play();
          this.video.muted = false;
        } else {
          this.video.pause();
          this.isPlaying = false;
        }
      }
    }
  }

  fullyLoaded() {
    if (this.isFullyLoaded) return;
    this.setVideoState({
      message: 'fullyLoaded',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      element: this.element.id!,
    });
    if (this.video) {
      this.video.currentTime = this.element.data.lastSeeked || 0;
    }
    this.isFullyLoaded = true;
  }

  setIsVideoPlaying(target: HTMLVideoElement) {
    this.isPlaying = this.videoIsPlaying(target);
  }

  onPlay(event: MediaStreamEvent) {
    this.isPlaying = this.videoIsPlaying(event.target as HTMLVideoElement) || !this.isGuest;
    setTimeout(() => this.setIsVideoPlaying(event.target as HTMLVideoElement), 500);
    if (this.isGuest) return;
    this.updateElement({
      ...this.element,
      data: {
        ...this.element.data,
        state: 'playing',
        lastSeeked: (event.target as HTMLVideoElement).currentTime,
      },
    });
  }

  onPause(event: MediaStreamEvent) {
    this.isPlaying = this.videoIsPlaying(event.target as HTMLVideoElement);
    setTimeout(() => this.setIsVideoPlaying(event.target as HTMLVideoElement), 500);
    if (this.isGuest) return;
    this.updateElement({
      ...this.element,
      data: {
        ...this.element.data,
        state: 'paused',
        lastSeeked: (event.target as HTMLVideoElement).currentTime,
      },
    });
  }

  onSeeked(event: MediaStreamEvent) {
    if (this.isGuest) return;
    this.updateElement({
      ...this.element,
      data: {
        ...this.element.data,
        lastSeeked: (event.target as HTMLVideoElement).currentTime,
      },
    });
  }

  onLoad(event: MediaStreamEvent) {
    const el = event?.target as HTMLMediaElement;
    if (this.element.width === 0 && this.element.height === 0 && !this.isGuest) {
      this.updateElement({
        ...this.element,
        width: el.clientWidth,
        height: el.clientHeight,
      });
    }
  }
}
